import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface MediaCardProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  onClick?: () => void;
}

export function MediaCard({ children, sx, onClick }: MediaCardProps): ReactNode {
  return (
    <Box
      {...(onClick === undefined ? {} : { component: 'button', type: 'button', onClick })}
      sx={[
        (theme) => ({
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: theme.palette.border.default,
          borderRadius: `${theme.radius.xl}px`,
          boxShadow: 2,
        }),
        onClick === undefined
          ? {}
          : { font: 'inherit', textAlign: 'left', color: 'inherit', cursor: 'pointer', m: 0 },
        ...(Array.isArray(sx) ? sx : [sx]),
        { '@media print': { overflow: 'visible' } },
      ]}
    >
      {children}
    </Box>
  );
}
